// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-routes-App-Me-Settings-DataCard-data-card__dataCard--3CIuc{padding:16px;color:#d8dadc;font-size:1.2em;background:#121213;border-top:0.5px solid #272729;border-bottom:0.5px solid #272729}.src-routes-App-Me-Settings-DataCard-data-card__dataCard--3CIuc:last-child{border-bottom:0}.src-routes-App-Me-Settings-DataCard-data-card__dataCard--3CIuc p{margin:0 0 16px 0}.src-routes-App-Me-Settings-DataCard-data-card__status--34m7l p{margin-top:16px}\n", ""]);
// Exports
exports.locals = {
	"dataCard": "src-routes-App-Me-Settings-DataCard-data-card__dataCard--3CIuc",
	"status": "src-routes-App-Me-Settings-DataCard-data-card__status--34m7l"
};
module.exports = exports;
